import React    from 'react';
import Dropzone from 'react-dropzone';
import Spinner  from 'react-spinner';

export default class ImageForm extends React.Component {
  constructor(props) {
    super(props);
    this.url = this.props.url;
    this.state = {
      preview: this.props.preview,
      showSpinner: this.props.showSpinner
    };
  }

  onDrop = (files) => {
    this.attachment = files[0];
    this.putAttachment();
    this.setState({ showSpinner: true });
  }

  putAttachment() {
    var data = new FormData();
    data.append('attachment', this.attachment)

    $.ajax({
      type: "PUT",
      url: this.url,
      data: data,
      cache: false,
      dataType: 'json',
      processData: false,
      contentType: false,
      success: function(data) {
        this.setState({ preview: data.attachment_url, showSpinner: false });
      }.bind(this)
    });
  }

  spinner() {
    if (!this.state.showSpinner) return;
    return (
      <Spinner/>
    );
  }

  onClickDelete = () => {
    this.setState({ showSpinner: true });

    $.ajax({
      type: "DELETE",
      url: this.url,
      cache: false,
      processData: false,
      contentType: false,
      success: (this.props.afterDelete || this.afterDelete)
    });
  }

  afterDelete = (data) => {
    this.setState({
      preview: data.attachment_url,
      showSpinner: false }
    );
  }

  render() {
    var dropzoneRef;

    return (
      <div className='image-form'>
        <Dropzone multiple={false}
                  accept='image/*'
                  onDrop={this.onDrop}
                  className='thumbnail'
                  ref={(node) => { dropzoneRef = node }}>
          <img className='img-responsive' src={this.state.preview}/>
        </Dropzone>

        <div className="dropdown">
          <a className='btn btn-warning btn-sm'
             data-toggle="dropdown">
            <i className="icon-pencil icon"></i>
          </a>
          <ul className="dropdown-menu">
            <li>
              <a onClick={() => { dropzoneRef.open() }}>Изменить</a>
            </li>
            <li>
              <a onClick={this.onClickDelete} className="text-danger">Удалить</a>
            </li>
          </ul>
        </div>

        {this.spinner()}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./app/javascript/components/image_form.jsx